import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { endpoints } from '../../utils/endpoints';
import {
    RemoveImageRequest,
    UploadImageRequest,
    UploadToken,
    UploadTokenRequest,
} from '../models/media.model';

@Injectable({
    providedIn: 'root',
})
export class MediaService {
    private http = inject(HttpClient);


    requestUploadToken(request: UploadTokenRequest) {
        let params = new HttpParams();
        params = params.append('mediaType', request.mediaType);

        return this.http.post<UploadToken>(
            endpoints.media.children.getRequestUploadTokenUrl(
                request.domain,
                request.targetId
            ),
            {},
            { params }
        );
    }

    uploadImage(request: UploadImageRequest, token: UploadToken) {
        let params = new HttpParams();
        params = params.append('requestToken', token.token);
        params = params.append('xOffset', request.xOffset);
        params = params.append('yOffset', request.yOffset);
        params = params.append('width', request.width);
        params = params.append('height', request.height);

        const formData = new FormData();
        formData.append('image', request.image);

        return this.http.post<void>(
            endpoints.media.children.getUploadImageUrl(),
            formData,
            { params }
        );
    }

    removeImageFile(request: RemoveImageRequest) {
        let params = new HttpParams();
        params = params.append('mediaType', request.mediaType);

        return this.http.delete<void>(
            endpoints.media.children.getRemoveImageUrl(
                request.domain,
                request.targetId
            ),
            { params }
        );
    }
}
